import { createStore } from 'vuex'


// var URL_APP = 'http://localhost:5005/';
var URL_APP = 'https://server-web.konaweselatankab.go.id/';
var URL_APP_EGOV = 'https://server-egov.konaweselatankab.go.id/';

export default createStore({
  state: { 
    egov:{
      UPLOADS :URL_APP_EGOV+'uploads/',

    },
    BASE_URL: URL_APP,
    UPLOADS: URL_APP+'uploads/',
    URL_API: 'https://server-web.konaweselatankab.go.id/api/v1/web_publish_berita/',

    URL_home:{
      listLink: URL_APP+'/api/v1/web_publish_berita/'

    },

    URL:{
      berita                    : URL_APP+"api/v1/web_publish_berita/",
      sambutan                  : URL_APP+"api/v1/publish_bpkad_sambutan/",
      dataPegawai               : URL_APP+"api/v1/publish_bpkad_data_pegawai/",
      tupoksi                   : URL_APP+"api/v1/publish_bpkad_tupoksi/",
      tentang                   : URL_APP+"api/v1/publish_bpkad_tentang/",
      struktur_organisasi       : URL_APP+"api/v1/publish_bpkad_struktur_organisasi/",
      visi_misi                 : URL_APP+"api/v1/publish_bpkad_visi_misi/",
      bpkad_unit_kerja          : URL_APP+"api/v1/publish_bpkad_unit_kerja/",
 
      peraturan                 : URL_APP+"api/v1/publish_bpkad_peraturan/",
      bpkad_data                : URL_APP+"api/v1/publish_bpkad_data/",
      sop                       : URL_APP+"api/v1/publish_bpkad_sop/",
      transparansi_anggaran     : URL_APP+"api/v1/publish_bpkad_transparansi_anggaran/",
      pengelolaan_hbo           : URL_APP+"api/v1/publish_bpkad_pengelolaan_hbo/",
      foto                      : URL_APP+"api/v1/publish_bpkad_foto/",
      video                     : URL_APP+"api/v1/publish_bpkad_video/",
      realisasi_anggaran        : URL_APP+"api/v1/publish_bpkad_realisasi_anggaran/",
      realisasi_pad             : URL_APP+"api/v1/publish_bpkad_realisasi_pad/",
      pad_opd                   : URL_APP+"api/v1/publish_bpkad_pad_opd/",

      link_terkait              : URL_APP+"api/v1/web_publish_link_terkait/",

    },


    isVisible: false,


  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
